var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"list-disc px-8"},_vm._l((_vm.sortedItems),function(item,i){return _c('li',{key:i,staticClass:"text-xs",class:{ 'line-through': item.complete },attrs:{"data-testid":"list-item"}},[_vm._v(" "+_vm._s(item.name)+" ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }